export default __webpack_public_path__ + "static/img-triple-crown-heading-32567a14c0367329df059baeb412c4b0.png";